import { POST_METHOD } from './ApiMethods';

export const postDocuments = async (document, dispatch) => {
    try {
        // const config = {
        //     onUploadProgress: (progressEvent) => {
        //         const { loaded, total } = progressEvent;
        //         var percentCompleted = Math.round((loaded / total) * 100);
        //         dispatch({ type: 'DOC_UPLOAD_PROGRESS', payload: percentCompleted });
        //     },
        // };
        let response = await POST_METHOD('upload/attachment', document);
        return response;
    } catch (error) {
        return error;
    }
};

export const deleteDocument = async (docDetails) => {
    try {
        const response = await POST_METHOD('delete/attachment', docDetails);
        return response;
    } catch (error) {
        return error;
    }
};
